import angular from 'angular';
import stPassengersComponent from './stPassengers.component';
import translate from 'angular-translate';

let stPassengersModule = angular.module('stPassengers', [
    translate
])
    .component('stPassengers', stPassengersComponent)
    .name;

export default stPassengersModule;



// WEBPACK FOOTER //
// ./client/app/common/stPassengers/stPassengers.js